#!/usr/bin/env node
import { runCodemod } from './controller';

void runCodemod();
